var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('em',{staticClass:"el-icon-search",staticStyle:{"cursor":"pointer","position":"absolute","right":"160px","line-height":"60px"},on:{"click":_vm.goSearchPage}})])}
var staticRenderFns = []

export { render, staticRenderFns }